import React from 'react';
import { Typography, Tooltip } from 'antd';

const { Text } = Typography;

export const ASSIGNEE_ROLES = [
  { label: 'Teklif', userField: 'offerAssignee', idField: 'offerAssigneeUserId' },
  { label: 'Plan', userField: 'planAssignee', idField: 'planAssigneeUserId' },
  { label: 'Yasal', userField: 'legalAssignee', idField: 'legalAssigneeUserId' },
  { label: 'Rapor', userField: 'reportAssignee', idField: 'reportAssigneeUserId' },
  { label: 'Fatura', userField: 'invoiceAssignee', idField: 'invoiceAssigneeUserId' },
  { label: 'Finans', userField: 'financeAssignee', idField: 'financeAssigneeUserId' },
];

const STATUS_ASSIGNEE_ROLE_MAP: Record<number, string> = {
  11: 'Teklif',
  4: 'Fatura',
  5: 'Rapor',
  12: 'Teklif',
  2: 'Teklif',
  6: 'Plan',
  14: 'Teklif',
  10: 'Teklif',
  3: 'Teklif',
  13: 'Teklif',
  7: 'Yasal',
};

const formatAssigneeLabel = (assignee?: any, fallbackId?: number) => {
  if (assignee) {
    const name = `${assignee.firstName ?? ''} ${assignee.lastName ?? ''}`.trim();
    if (name) {
      return name;
    }
    if (assignee.email) {
      return assignee.email;
    }
    if (assignee.id) {
      return String(assignee.id);
    }
  }
  if (fallbackId) {
    return String(fallbackId);
  }
  return '-';
};

export interface AssigneeSummaryProps {
  record: Record<string, any>;
  statusId?: number;
  maxWidth?: number;
  fontSize?: number;
}

const AssigneeSummary: React.FC<AssigneeSummaryProps> = ({
  record,
  statusId,
  maxWidth = 220,
  fontSize = 12,
}) => {
  if (!record) {
    return <Text>-</Text>;
  }

  const textSize = Math.max(8, Math.round(fontSize * 0.9));
  const filteredRoleLabel = statusId ? STATUS_ASSIGNEE_ROLE_MAP[statusId] : undefined;
  const filteredRoles =
    filteredRoleLabel && ASSIGNEE_ROLES.find((role) => role.label === filteredRoleLabel)
      ? ASSIGNEE_ROLES.filter((role) => role.label === filteredRoleLabel)
      : ASSIGNEE_ROLES;

  const renderNameList = (roles: typeof ASSIGNEE_ROLES) => {
    const labels = roles
      .map((role) => formatAssigneeLabel(record[role.userField], record[role.idField]))
      .filter((label): label is string => Boolean(label));

    if (!labels.length) {
      return <Text style={{ fontSize: textSize }}>-</Text>;
    }

    return (
      <div style={{ display: 'flex', flexDirection: 'column', gap: 2, fontSize, maxWidth }}>
        {labels.map((label, index) => (
          <Text
            key={`${label}-${index}`}
            style={{ whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', fontSize: textSize }}
            title={label}
          >
            {label}
          </Text>
        ))}
      </div>
    );
  };

  const renderRoleListWithLabels = (roles: typeof ASSIGNEE_ROLES) => (
    <div style={{ display: 'flex', flexDirection: 'column', gap: 2, fontSize, maxWidth }}>
      <span><b style={{color: 'black', fontSize: 13}}>Sorumlular</b></span>
      {roles.map((role) => {
        const label = formatAssigneeLabel(record[role.userField], record[role.idField]) ?? '-';
        return (
          <div key={role.label} style={{ display: 'flex', gap: 6, alignItems: 'center' }}>
            <Text style={{ minWidth: 55, fontSize: textSize, fontWeight: 600 }}>{role.label}:</Text>
            <Text
              style={{ whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', fontSize: textSize }}
              title={label}
            >
              {label}
            </Text>
          </div>
        );
      })}
    </div>
  );

  return (
    <Tooltip color="white" title={renderRoleListWithLabels(ASSIGNEE_ROLES)} overlayInnerStyle={{ padding: 8 }}>
      <div>{renderNameList(filteredRoles)}</div>
    </Tooltip>
  );
};

export default AssigneeSummary;
